const API_URL = process.env.VUE_APP_API_URL
const FLAGR_UI_POSSIBLE_ENTITY_TYPES = process.env.VUE_APP_FLAGR_UI_POSSIBLE_ENTITY_TYPES

export default {
  API_URL,
  FLAGR_UI_POSSIBLE_ENTITY_TYPES
}
